// removed by extract-text-webpack-plugin
module.exports = {"RegisterInterest":"RegisterInterestForm__RegisterInterest___1sVNk","RegisterInterestForm":"RegisterInterestForm__RegisterInterestForm___LhVx7","RegisterInterestFormText":"RegisterInterestForm__RegisterInterestFormText___1ZpQG","requiredStar":"RegisterInterestForm__requiredStar___2FWoi"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/RegisterInterestForm/RegisterInterestForm.less
// module id = 1202
// module chunks = 0 1